/**
 * Entitlement read client (T64). Wraps the BE T66 endpoint
 * GET /api/v1/me/entitlements so the FE can decide whether to render Pro
 * surfaces vs the upgrade CTA. Backend still enforces every Pro endpoint
 * via @RequiresEntitlement — this is a UX shortcut, not a security gate.
 */
import { apiClient } from "../api/client";

export interface EntitlementRow {
  /** Stable code, e.g. "module.multi-branch", "module.coupon", "screen.appointments". */
  code: string;
  /** Free-text value when the entitlement carries one (SLA tier, etc.). */
  value: string | null;
  /** Numeric limit when the entitlement is quantitative (e.g. limit.users). */
  limit: number | null;
  /** Derived: true when the tenant has a meaningful value for this code. */
  enabled: boolean;
}

export interface EntitlementsResponse {
  entitlements: EntitlementRow[];
  /** Phòng khám đang đứng ở đâu về thanh toán (#18972). Vắng trên máy chủ cũ hơn. */
  billingState?: "ACTIVE" | "GRACE" | "READ_ONLY";
}

export const entitlementsApi = {
  mine(): Promise<EntitlementsResponse> {
    return apiClient.get<EntitlementsResponse>("/v1/me/entitlements").then((r) => r.data);
  },
};

export const entitlementsQueryKeys = {
  mine: () => ["me", "entitlements"] as const,
};
